import { motion } from "framer-motion";
import { Factory, Building2, Home, Store, Shield, Sun, ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "../lib/data";

const ICONS = { Factory, Building2, Home, Store, Shield, Sun };

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[#0A0B0E] py-24 lg:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em]">
                Nuestros servicios
              </span>
            </div>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Polarizado profesional para{" "}
              <span className="italic text-[#D4AF37]">cada tipo de espacio</span>.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-base lg:text-lg text-white/55 font-light leading-relaxed">
              Instalamos película de polarizado con materiales de primera línea.
              Cada proyecto incluye asesoría sin costo y garantía de instalación.
              Cotiza enviándonos las medidas aproximadas por WhatsApp.
            </p>
          </div>
        </div>

        {/* Asymmetrical bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];

            return (
              <motion.a
                key={s.id}
                href={waLink(s.waMsg)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
                className="group relative overflow-hidden rounded-2xl border border-white/8 bg-[#14161C] min-h-[440px] hover:border-[#D4AF37]/40 transition-all duration-500"
              >
                {/* Background image */}
                <div className="absolute inset-0 opacity-30 group-hover:opacity-50 transition-opacity duration-700">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.5s]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E] via-[#0A0B0E]/70 to-transparent" />
                </div>

                <div className="relative h-full p-8 lg:p-10 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 flex items-center justify-center group-hover:bg-[#D4AF37]/15 transition-colors">
                      {Icon && <Icon size={20} className="text-[#D4AF37]" />}
                    </div>
                    <ArrowUpRight
                      size={22}
                      className="text-white/40 group-hover:text-[#D4AF37] group-hover:rotate-12 transition-all"
                    />
                  </div>

                  <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-3">
                      {s.subtitle}
                    </div>
                    <h3 className="font-display text-3xl lg:text-4xl text-white mb-4 leading-tight tracking-tight">
                      {s.title}
                    </h3>
                    <p className="text-sm text-white/55 leading-relaxed font-light mb-5">
                      {s.description}
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {s.tags.map((t) => (
                        <span
                          key={t}
                          className="text-xs px-3 py-1 rounded-full border border-white/10 bg-white/5 text-white/70"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
